export default __webpack_public_path__ + "static/media/challenge.0c7ed39b.webp";